import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './COEAdmin.css';
import { CSVLink } from 'react-csv';
import moment from 'moment-timezone';

function COEAdmin() {
    const [responses, setResponses] = useState([]);
    const [csvData, setCsvData] = useState([]);
    const [isAuthorized, setIsAuthorized] = useState(false);

    useEffect(() => {
        fetch(`${process.env.REACT_APP_AI_FORM_SERVER}/api/getResponses?_=${new Date().getTime()}`)
            .then(res => res.json())
            .then(data => {
                if (data.success) {
                    setResponses(data.data);
                    processCsvData(data.data); // Process the data into CSV format
                } else {
                    alert('Failed to fetch responses');
                }
            })
            .catch(error => console.log('Error fetching responses:', error));
    }, []);


    const processCsvData = (data) => {
        if (!data || data.length === 0) return; // Return early if there's no data

        // Create a header row with field names, including keys from the 'response' object
        const headers = Object.keys(data[0]).flatMap((key) => {
            if (key === 'response' && data[0][key] && typeof data[0][key] === 'object') {
                // Extract keys from the response object (key-value pairs)
                return Object.keys(data[0][key]).map(responseKey => `response_${responseKey}`);
            }
            return key; // For other fields, just return the key as is
        });

        // Format each response into a row with flattened response keys and values
        const formattedData = data.map((entry) => {
            return Object.keys(entry).flatMap((key) => {
                if (key === 'response' && entry[key] && typeof entry[key] === 'object') {
                    // Flatten the response object into individual columns for each key-value pair
                    return Object.values(entry[key]);
                }
                return entry[key]; // Return other fields as they are
            });
        });

        // Set headers and data for CSV export
        setCsvData([headers, ...formattedData]);
    };


    // Handle CSV download with password prompt
    const handleDownload = () => {
        const password = prompt("Enter password to download CSV:");
        if (password === "Island@308") {
            setIsAuthorized(true);
        } else {
            alert("Incorrect password!");
        }
    };

    return (
        <div className="admin-container">
            <h1>COE Form Admin Page</h1>
            {!isAuthorized ? (
                <button onClick={handleDownload} className="download-btn">
                    Key In Passcode
                </button>
            ) : (

                <CSVLink 
                data={csvData} 
                        //  headers={csvHeaders}
                 filename={`COEFormResponse_${moment().tz('Asia/Kuala_Lumpur').format('DD_MM_YYYY_HH_mm_ss')}.csv`}
                 id="csvDownloadLink"
                >
                        <button className="download-btn">Download CSV</button>
      </CSVLink>

            )}
        </div>
    );
};

export default COEAdmin;
